export enum ERoleAccessIsAny {
	Any = 'any',
	Custom = 'custom',
}

export const ROLE_ACCESS_IS_ANY_LABEL_MAP: Record<ERoleAccessIsAny, string> = {
	[ERoleAccessIsAny.Any]: `role_access_is_any.${ERoleAccessIsAny.Any}`,
	[ERoleAccessIsAny.Custom]: `role_access_is_any.${ERoleAccessIsAny.Custom}`
}
